module.exports = __webpack_public_path__ + "static/media/facility-north-01sm.715b886f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facility-north-01sm.jpg
// module id = 30
// module chunks = 0